import {DeliverableInput} from "@/endpoints/rutsolve/gql/generated/types"

export class DeliverableSelector {
    static readonly deliverableInput: string = "DELIVERABLE_SELECTOR_DELIVERABLE_INPUT"
    static readonly selectedDeliverableID: string = "DELIVERABLE_SELECTOR_SELECTED_DELIVERABLE_ID"

    private static defaultDeliverableInput: DeliverableInput = {
        deliverableFilter: {
            types: []
        },
        order: "UPDATED_AT_DESCENDING",
        plot: {
            items: 10,
            page: 1
        },
    }

    public static readDeliverableInput(): DeliverableInput {
        const deliverableInput = sessionStorage.getItem(this.deliverableInput)
        if (deliverableInput) {
            return JSON.parse(deliverableInput) as DeliverableInput
        }
        return this.defaultDeliverableInput
    }

    public static readSelectedDeliverableID(): string {
        return sessionStorage.getItem(this.selectedDeliverableID)
    }

    public static writeDeliverableInput(input: DeliverableInput) {
        sessionStorage.setItem(this.deliverableInput, JSON.stringify(input))
    }

    public static writeSelectedDeliverableID(input: string) {
        sessionStorage.setItem(this.selectedDeliverableID, input)
    }

    public static deleteDeliverableInput() {
        sessionStorage.removeItem(this.deliverableInput)
    }

    public static deleteSelectedDeliverableID() {
        sessionStorage.removeItem(this.selectedDeliverableID)
    }
}
